export default __webpack_public_path__ + "static/media/brandsImage-2.c862e29e.jpg";